import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flag: false, //菜单栏左右滑动标志
    userName: '', // 管理端登录人
    fullPath: '', // 路由全路径
    hash: '', // hash路由回显
    companyNews: {
      name: '江苏晓羊信息技术有限公司',
      profile: '江苏晓羊信息技术有限公司成立于2019年09月27日，注册地位于南京市江宁开发区迎翠路7号1幢中关村软件园二层楼东区206室（江宁开发区），法定代表人为周林。经营范围包括计算机信息技术研发、技术服务、技术咨询；科技培训；软件开发；计算机系统集成服务；会议服务；展览展示服务；自营和代理各类商品及技术的进出口业务（国家限制企业经营和禁止进出口的商品和技术除外）；计算机软件及辅助设备、电子产品销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）一般项目：物联网技术研发；物联网技术服务；物联网应用服务；物联网设备制造；物联网设备销售（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）江苏晓羊信息技术有限公司对外投资1家公司。',
      tel: '025-52833892',
      address: '江苏省南京市江宁区千人创业大厦',
      fax: '00852XXXXXXX', // 传真
      mailbox: '21175983@qq.com',
      declaration: '让教育更加高效而美好',
      headquarters: '北京晓羊教育科技集团有限公司'
    },
    companySet: {}, // 公司设置
    websiteSet: {}, // 网站设置
    subNews: [], // 导航菜单
    linkLStr:'interpretaion,ability,map,know,news,honor,contact'

  },
  getters: {},
  mutations: {
    toggle(state) {
      state.flag = !state.flag
    },
    getUserName(state, data) {
      state.userName = data
    },
    getHash (state, data) {
      state.hash = data
    },
    getFullPath (state, data) {
      state.fullPath = data
    },
    getMenu (state, data) {
      state.subNews = data
    },
    getCompanySet (state, data) {
      state.companySet = data
    },
    getWebsiteSet (state, data) {
      state.websiteSet = data
    },
  },
  actions: {},
  modules: {}
})
